export const MAX_FILE_UPLOAD_SIZE_BYTES = 200 * 1024 * 1024;
